module.exports = {
  NO_STOCK: "We don’t currently know when this item will be back in stock.",
  ZERO_TO_SIX_DAYS: "We hope to receive stock of this item <b>within the next 1-2 weeks</b>",
  SEVEN_TO_THIRTEEN_DAYS: "We hope to receive stock of this item <b>within the next 2-3 weeks</b>",
  FOURTEEN_TO_TWENTY_DAYS: "We hope to receive stock of this item <b>within the next 3-4 weeks</b>",
  TWENTY_ONE_TO_TWENTY_SEVEN_DAYS: "We hope to receive stock of this item <b>within the next 4-5 weeks</b>",
  TWENTY_EIGHT_TO_FIFTY_FIVE_DAYS: "We hope to receive stock of this item <b>within the next 6-8 weeks</b>",
  FIFTY_SIX_TO_EIGHTY_THREE_DAYS: "We hope to receive stock of this item <b>within the next few months</b>",
  NO_PRODUCT: "We don’t currently know when this item will be back in stock.",
};
